import React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import dayjs from "dayjs";
import { showInIQD } from "../../customFunction/Numeral/CurrencyFormat";
import { useQuery } from "../Users/GetUserCredentialsScreen";
import RequestModal from "../../components/utils/RequestModal";
import ShowPaginationData from "../../components/UI/TableView/ShowPaginationData";
import { IoAdd } from "react-icons/io5";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

// only for showing cafe orders balance, cash, card
export default function RequestedCourse() {
  const { t } = useTranslation();
  const type = useQuery().get('type')
  const history = useHistory()
  const { columns, id, label, url, href } = {
    id: "cafeteria",
    label: "Cafeteria",
    href: '/cafeteria',
    columns: [{ label: type == 7 ? "userName" : '#', value: a => type == 7 ? a.user?.name : a._id.slice(10) },
    { label: 'name', sort: 'name', classnames: () => 'font-[Montserrat]', value: (a) => t(a.name) },
    { label: 'price', sort: 'price', value: (a) => showInIQD(a.price, 'USD') + ' - ' + showInIQD(a.iqd) },
    { label: 'date', sort: 'createdAt', value: (a) => dayjs(a.createdAt).format('YYYY-MM-DD HH:mm') },
    ],
    url: (centerId) => `/orders?type=${type}&isList=true&startDate=${dayjs().format('YYYY-MM-DD')}&endDate=${dayjs().format('YYYY-MM-DD')}&fromReception=true&` + centerId,
  }
  const [requestModal, setRequestModal] = useState(false)
  const [currentOrder, setCurrentOrder] = useState(false)

  const sendRequest = (data) => {
    setCurrentOrder(data)
    setRequestModal(!requestModal)
  }

  const onPressAdd = () => {
    history.push(window.location.pathname + '/0')
  }

  return (
    <div className="flex flex-col items-center w-full bg-white">
      {/* {requestModal && <RequestModal data={currentOrder} requestType={4} toggleModal={sendRequest} />} */}

      <ShowPaginationData defaultSort={[{ sort: 'createdAt', sortBy: 1 }]} hrefId={null} onClickItem={(_id) => sendRequest(_id)} rightButton={<div className="cursor-pointer" >
        <IoAdd size={40} onClick={onPressAdd} />
      </div>} columns={columns} href={href} id={id} label={label} url={url} />
    </div>
  );
}
